"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _actions = require("../../../../../actions");
var _dsWeb = require("@olxbr/ds-web");
var _dsIcons = require("@olxbr/ds-icons");
var _style = require("./style");
var _WalkthroughTooltip = _interopRequireDefault(require("../WalkthroughTooltip"));
var _isSsr = require("../../../../../helpers/isSsr");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var IconFavoriteChat = function IconFavoriteChat(_ref) {
  var chat = _ref.chat,
    index = _ref.index,
    favoriteChatAction = _ref.favoriteChatAction,
    viewFavoriteAction = _ref.viewFavoriteAction,
    selectFavoriteAction = _ref.selectFavoriteAction,
    unselectFavoriteAction = _ref.unselectFavoriteAction,
    selectFavoriteErrorAction = _ref.selectFavoriteErrorAction,
    unselectFavoriteErrorAction = _ref.unselectFavoriteErrorAction,
    reloadChatList = _ref.reloadChatList;
  var isFavoriteChat = chat.isFavoriteChat,
    roomname = chat.roomname,
    adStatus = chat.adStatus;
  var joyrideRef = (0, _react.useRef)(null);
  var favoriteCookie = (0, _isSsr.isCsr)() && window.localStorage.getItem('tourFavoriteChatClosed');
  var ADD_FAVORITE = (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation UpdateChat {\n      updateChat(roomname: \"", "\", favorite: true) {\n          success\n      }\n    }\n  "])), roomname);
  var REMOVE_FAVORITE = (0, _client.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation UpdateChat {\n      updateChat(roomname: \"", "\", favorite: false) {\n          success\n      }\n    }\n  "])), roomname);
  var _useMutation = (0, _client.useMutation)(ADD_FAVORITE),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    mutateAddFavorite = _useMutation2[0];
  var _useMutation3 = (0, _client.useMutation)(REMOVE_FAVORITE),
    _useMutation4 = _slicedToArray(_useMutation3, 1),
    mutationRemoveFavorite = _useMutation4[0];
  (0, _react.useEffect)(function () {
    if (index === 0) {
      viewFavoriteAction();
    }
  }, []);
  var handleSelectFavorite = function handleSelectFavorite(event) {
    event.stopPropagation();
    mutateAddFavorite().then(function (_ref2) {
      var _data$updateChat;
      var data = _ref2.data;
      if (data !== null && data !== void 0 && (_data$updateChat = data.updateChat) !== null && _data$updateChat !== void 0 && _data$updateChat.success) {
        favoriteChatAction(chat);
        selectFavoriteAction();
      } else {
        selectFavoriteErrorAction();
      }
    })["catch"](function () {
      selectFavoriteErrorAction();
    });
  };
  if (adStatus !== 'active') {
    return null;
  }
  var handleUnselectFavorite = function handleUnselectFavorite(event) {
    event.stopPropagation();
    mutationRemoveFavorite().then(function (_ref3) {
      var _data$updateChat2;
      var data = _ref3.data;
      if (data !== null && data !== void 0 && (_data$updateChat2 = data.updateChat) !== null && _data$updateChat2 !== void 0 && _data$updateChat2.success) {
        favoriteChatAction(chat);
        unselectFavoriteAction();
      } else {
        unselectFavoriteErrorAction();
      }
    })["catch"](function () {
      unselectFavoriteErrorAction();
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.IconFavorite, {
      id: index === 0 ? 'step1' : '',
      children: isFavoriteChat ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.HeartFilled, {
          color: "var(--color-neutral-120)",
          size: "20"
        }),
        onClick: handleUnselectFavorite,
        hideVisibleLabel: true,
        label: "Favoritar chat"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.IconAction, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Heart, {
          color: "var(--color-neutral-120)",
          size: "20"
        }),
        onClick: handleSelectFavorite,
        hideVisibleLabel: true,
        label: "Desfavoritar chat"
      })
    }), index === 0 && !favoriteCookie ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_WalkthroughTooltip["default"], {
      joyrideRef: joyrideRef,
      reloadChatList: reloadChatList
    }) : null]
  });
};
IconFavoriteChat.propTypes = {
  chat: _propTypes["default"].object.isRequired,
  index: _propTypes["default"].number.isRequired,
  favoriteChatAction: _propTypes["default"].func.isRequired,
  viewFavoriteAction: _propTypes["default"].func.isRequired,
  selectFavoriteAction: _propTypes["default"].func.isRequired,
  unselectFavoriteAction: _propTypes["default"].func.isRequired,
  reloadChatList: _propTypes["default"].func.isRequired,
  selectFavoriteErrorAction: _propTypes["default"].func.isRequired,
  unselectFavoriteErrorAction: _propTypes["default"].func.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    viewFavoriteAction: _actions.viewFavorite,
    favoriteChatAction: _actions.favoriteChat,
    selectFavoriteAction: _actions.selectFavorite,
    unselectFavoriteAction: _actions.unselectFavorite,
    selectFavoriteErrorAction: _actions.selectFavoriteError,
    unselectFavoriteErrorAction: _actions.unselectFavoriteError
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(null, mapDispatchToProps)(IconFavoriteChat);